import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import moment from 'moment'
import './index.scss'

const DeclineChatMess = ({ img, time, name, town, goTo, story }) => (
  <Grid className='declineChatBox' onClick={goTo}>
    <img src={story?.image?.src} className='storyImg' />
    <Typography className='titleStory'>"{story?.title}"</Typography>
    <Typography className='text'>"The author declined your meeting request.<br /> We're sorry that happened. Don't feel bad:<br /> there are plenty of people to meet."</Typography>
    <Typography className='timeDecline'>{moment(+time).format('h:mm A')}</Typography>
  </Grid>
)

export default DeclineChatMess
